<template>
<!-- Messenger Clone -->
<div class="h-screen w-full flex antialiased text-gray-200 bg-gray-900 overflow-hidden">
    <div class="flex-1 flex flex-col">
        <div class="border-b-2 border-gray-800 p-2 flex flex-row z-20">
            <div class="bg-red-600 w-3 h-3 rounded-full mr-2"></div>
            <div class="bg-yellow-500 w-3 h-3 rounded-full mr-2"></div>
            <div class="bg-green-500 w-3 h-3 rounded-full mr-2"></div>
        </div>
        <main class="flex-grow flex flex-row min-h-0">
            <section class="flex flex-col flex-none overflow-auto w-24 hover:w-64 group lg:max-w-sm md:w-2/5 transition-all duration-300 ease-in-out">
                <div class="header p-4 flex flex-row justify-between items-center flex-none">
                    <div class="w-16 h-16 relative flex flex-shrink-0" style="filter: invert(100%);">
                        <svg xmlns="http://www.w3.org/2000/svg" width="124.544" height="82.686" viewBox="0 0 124.544 82.686">
                            <g id="LOGO" transform="translate(-173.211 -60.245)">
                                <rect id="Rectángulo_216" data-name="Rectángulo 216" width="3.657" height="19.457" transform="translate(215.943 60.257)" fill="#000"/>
                                <path id="Trazado_2051" data-name="Trazado 2051" d="M176.666,183.106V173.014h-3.455v23.914h3.455v-10.4h10.127v10.4h3.49V173.014h-3.49v10.092ZM211.4,196.927h3.695l-9.613-24.256h-2.532l-9.614,24.256h3.729c2.37-6.246,4.789-12.45,7.185-18.748,2.451,7.04,4.371,11.934,7.15,18.748Zm15.609-23.948H218.25v23.948h3.489v-4.313h0V182.366h0v-5.9h5.269a4.537,4.537,0,0,1,0,9.066h-2.447v3.421h2.447c5.166,0,7.766-3.969,7.766-7.972s-2.6-8.005-7.766-8.005Zm20.877,0h-8.758v23.948h3.489v-7.971h0v-3.421h0v-9.066h5.268a4.537,4.537,0,0,1,0,9.066h-2.44v3.421h2.44c5.166,0,7.767-3.969,7.767-7.972s-2.6-8.005-7.767-8.005Zm15.541,20.493h0V186.7H274.27v-3.489H263.425v-6.74H274.51v-3.455H259.935v23.914h14.609v-3.455Zm21.123-8.69h0v1.642l8.725,10.5h4.482l-7.561-9a7.209,7.209,0,0,0,6.192-7.321,7.417,7.417,0,0,0-7.8-7.629h-8.724v23.948h3.421V176.469h5.3a4.161,4.161,0,1,1,0,8.313Z" transform="translate(0 -53.996)" fill="#000" fill-rule="evenodd"/>
                                <path id="Trazado_2052" data-name="Trazado 2052" d="M293.71,60.257h-3.656V75.82a89.586,89.586,0,0,1-11.04.246c-2.51-.036-4.215-.07-5.93.01l-.056-6.057.007-9.763h-3.6L269.3,79.721h.427q1.994,0,3.981-.011c1.677-.008,2.676-.016,4.358-.01.984,0,2.036.029,3.149.057,1.254.032,2.562.064,3.869.064a31.211,31.211,0,0,0,7.408-.683c8.321-2.129,8.331-9.443,8.338-15.9,0-.744,0-1.482.015-2.186l.015-.239-.037-.524-3.46-.047-.037,1.43c-.011.447-.008.979-.005,1.594.013,2.625.034,6.6-1.138,8.811a5.094,5.094,0,0,1-2.475,2.663Z" transform="translate(-46.15 0)" fill="#000" fill-rule="evenodd"/>
                                <rect id="Rectángulo_217" data-name="Rectángulo 217" width="3.657" height="19.457" transform="translate(251.069 86.354)" fill="#000"/>
                                <path id="Trazado_2053" data-name="Trazado 2053" d="M262.614,129.841h3.656V114.278a89.681,89.681,0,0,1,11.04-.247c2.51.036,4.215.07,5.931-.01l.056,6.058-.007,9.762h3.6l.134-19.464H286.6q-1.994,0-3.981.012c-1.677.007-2.676.015-4.358.01-.984,0-2.036-.029-3.149-.057-1.254-.032-2.562-.064-3.869-.064a31.211,31.211,0,0,0-7.408.683c-8.321,2.129-8.331,9.443-8.338,15.9,0,.744,0,1.482-.014,2.187l-.016.238.037.524,3.46.048.037-1.43c.011-.447.009-.979.005-1.594-.013-2.625-.034-6.6,1.138-8.811a5.1,5.1,0,0,1,2.475-2.663Z" transform="translate(-39.504 -24.029)" fill="#000" fill-rule="evenodd"/>
                            </g>
                        </svg>
                    </div>
                    <p class="text-md font-bold hidden md:block group-hover:block">Messenger</p>
                    <span></span>
                    <a @click="$router.go(-1)" class="block rounded-full hover:bg-gray-700 bg-gray-800 w-10 h-10 p-2 hidden md:block group-hover:block cursor-pointer">
                        <svg viewBox="0 0 20 20" class="w-full h-full fill-current">
                            <path d="M3.24,7.51c-0.146,0.142-0.146,0.381,0,0.523l5.199,5.193c0.234,0.238,0.633,0.064,0.633-0.262v-2.634c0.105-0.007,0.212-0.011,0.321-0.011c2.373,0,4.302,1.91,4.302,4.258c0,0.957-0.33,1.809-1.008,2.602c-0.259,0.307,0.084,0.762,0.451,0.572c2.336-1.195,3.73-3.408,3.73-5.924c0-3.741-3.103-6.783-6.916-6.783c-0.307,0-0.615,0.028-0.881,0.063V2.575c0-0.327-0.398-0.5-0.633-0.261L3.24,7.51 M4.027,7.771l4.301-4.3v2.073c0,0.232,0.21,0.409,0.441,0.366c0.298-0.056,0.746-0.123,1.184-0.123c3.402,0,6.172,2.709,6.172,6.041c0,1.695-0.718,3.24-1.979,4.352c0.193-0.51,0.293-1.045,0.293-1.602c0-2.76-2.266-5-5.046-5c-0.256,0-0.528,0.018-0.747,0.05C8.465,9.653,8.328,9.81,8.328,9.995v2.074L4.027,7.771z"></path>
                        </svg>
                    </a>
                </div>
                <div class="search-box p-4 flex-none">
                    <form onsubmit="">
                        <div class="relative">
                            <label>
                                <input 
                                  v-model="search" 
                                  @keyup="searchContact" 
                                  class="rounded-full py-2 pr-6 pl-10 w-full border border-gray-800 focus:border-gray-700 bg-gray-800 focus:bg-gray-900 focus:outline-none text-gray-200 focus:shadow-md transition duration-300 ease-in"
                                  type="text" 
                                  placeholder="Buscar contacto"/>
                                <span class="absolute top-0 left-0 mt-2 ml-3 inline-block">
                                    <svg viewBox="0 0 24 24" class="w-6 h-6">
                                        <path fill="#bbb"
                                              d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"/>
                                    </svg>
                                </span>
                            </label>
                        </div>
                    </form>
                </div>

                <div class="contacts p-2 flex-1 overflow-y-scroll">
                    <div @click="change(p.claimId)" v-for="(p, index) in people" :key="index" class="flex justify-between items-center p-3 hover:bg-gray-800 rounded-lg relative">
                        <div class="w-16 h-16 relative flex flex-shrink-0">
                            <img class="shadow-md rounded-full w-full h-full object-cover" alt="" :src="require('../assets/images/noavatar.png')"></img>
                            <div v-if="p.active" class="absolute bg-gray-900 p-1 rounded-full bottom-0 right-0">
                                <div class="bg-green-500 rounded-full w-3 h-3"></div>
                            </div>
                        </div>
                        <div class="flex-auto min-w-0 ml-4 mr-6 hidden md:block group-hover:block cursor-pointer">
                            <p class="font-bold">{{ p.contact }}</p>
                            <div v-if="p.lastMessage" class="flex items-center text-sm font-bold">
                                <div class="min-w-0">
                                    <p class="truncate">{{ p.lastMessage.message }}</p>
                                </div>
                                <p class="ml-2 whitespace-no-wrap">{{ p.lastMessage.created_at | fechaHoraDDMM }}</p>
                            </div>
                        </div>
                        <div v-if="p.active" class="bg-blue-700 w-3 h-3 rounded-full flex flex-shrink-0 hidden md:block group-hover:block"></div>
                    </div>
                </div>
            </section>
            <section class="flex flex-col flex-auto border-l border-gray-800">
                <div class="chat-header px-6 py-4 flex flex-row flex-none justify-between items-center shadow">
                    <div class="flex">
                        <div v-if="chat" class="w-12 h-12 mr-4 relative flex flex-shrink-0">
                            <img class="shadow-md rounded-full w-full h-full object-cover" alt="" :src="require('../assets/images/noavatar.png')" />
                        </div>
                        <div v-if="chat" class="text-sm cursor-pointer">
                            <router-link :to="{ name: 'ClaimEdit', params: { claimId: chat.claimId }}">
                                <p class="font-bold">{{ chat.contact }}</p>
                            </router-link>
                        </div>
                    </div>
                    <div class="flex">
                        <a @click="$router.go(0)" class="block rounded-full hover:bg-gray-700 bg-gray-800 w-10 h-10 p-2 cursor-pointer">
                            <svg viewBox="0 0 20 20" class="w-full h-full fill-current text-blue-500">
                                <path d="M12.319,5.792L8.836,2.328C8.589,2.08,8.269,2.295,8.269,2.573v1.534C8.115,4.091,7.937,4.084,7.783,4.084c-2.592,0-4.7,2.097-4.7,4.676c0,1.749,0.968,3.337,2.528,4.146c0.352,0.194,0.651-0.257,0.424-0.529c-0.415-0.492-0.643-1.118-0.643-1.762c0-1.514,1.261-2.747,2.787-2.747c0.029,0,0.06,0,0.09,0.002v1.632c0,0.335,0.378,0.435,0.568,0.245l3.483-3.464C12.455,6.147,12.455,5.928,12.319,5.792 M8.938,8.67V7.554c0-0.411-0.528-0.377-0.781-0.377c-1.906,0-3.457,1.542-3.457,3.438c0,0.271,0.033,0.542,0.097,0.805C4.149,10.7,3.775,9.762,3.775,8.76c0-2.197,1.798-3.985,4.008-3.985c0.251,0,0.501,0.023,0.744,0.069c0.212,0.039,0.412-0.124,0.412-0.34v-1.1l2.646,2.633L8.938,8.67z M14.389,7.107c-0.34-0.18-0.662,0.244-0.424,0.529c0.416,0.493,0.644,1.118,0.644,1.762c0,1.515-1.272,2.747-2.798,2.747c-0.029,0-0.061,0-0.089-0.002v-1.631c0-0.354-0.382-0.419-0.558-0.246l-3.482,3.465c-0.136,0.136-0.136,0.355,0,0.49l3.482,3.465c0.189,0.186,0.568,0.096,0.568-0.245v-1.533c0.153,0.016,0.331,0.022,0.484,0.022c2.592,0,4.7-2.098,4.7-4.677C16.917,9.506,15.948,7.917,14.389,7.107 M12.217,15.238c-0.251,0-0.501-0.022-0.743-0.069c-0.212-0.039-0.411,0.125-0.411,0.341v1.101l-2.646-2.634l2.646-2.633v1.116c0,0.174,0.126,0.318,0.295,0.343c0.158,0.024,0.318,0.034,0.486,0.034c1.905,0,3.456-1.542,3.456-3.438c0-0.271-0.032-0.541-0.097-0.804c0.648,0.719,1.022,1.659,1.022,2.66C16.226,13.451,14.428,15.238,12.217,15.238"></path>
                            </svg>
                        </a>
                    </div>
                </div>
                <div v-if="chat" class="chat-body p-4 flex-1 overflow-y-scroll">
                    <div 
                      v-for="c in chat.chat" :key="c.id" 
                      :class="[!c.person_response ? 'justify-start' : 'justify-end']"
                      class="pb-2 flex flex-row">
                        <div class="messages text-sm text-gray-700 grid grid-flow-row gap-2">
                            <div class="flex items-center group">
                                <p 
                                  :class="[!c.person_response ? 'bg-gray-800 rounded-r-full' : 'bg-blue-700 rounded-l-full']"
                                  class="px-6 py-3 max-w-xs lg:max-w-md text-gray-200">
                                    {{ c.message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="chat-footer flex-none">
                    <div class="flex flex-row items-center p-4">
                        <!--
                        <button type="button" class="flex flex-shrink-0 focus:outline-none mx-2 block text-blue-600 hover:text-blue-700 w-6 h-6">
                            <svg viewBox="0 0 20 20" class="w-full h-full fill-current">
                                <path d="M10,1.6c-4.639,0-8.4,3.761-8.4,8.4s3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4S14.639,1.6,10,1.6z M15,11h-4v4H9  v-4H5V9h4V5h2v4h4V11z"/>
                            </svg>
                        </button>
                        <button type="button" class="flex flex-shrink-0 focus:outline-none mx-2 block text-blue-600 hover:text-blue-700 w-6 h-6">
                            <svg viewBox="0 0 20 20" class="w-full h-full fill-current">
                                <path d="M11,13 L8,10 L2,16 L11,16 L18,16 L13,11 L11,13 Z M0,3.99406028 C0,2.8927712 0.898212381,2 1.99079514,2 L18.0092049,2 C19.1086907,2 20,2.89451376 20,3.99406028 L20,16.0059397 C20,17.1072288 19.1017876,18 18.0092049,18 L1.99079514,18 C0.891309342,18 0,17.1054862 0,16.0059397 L0,3.99406028 Z M15,9 C16.1045695,9 17,8.1045695 17,7 C17,5.8954305 16.1045695,5 15,5 C13.8954305,5 13,5.8954305 13,7 C13,8.1045695 13.8954305,9 15,9 Z" />
                            </svg>
                        </button>
                        <button type="button" class="flex flex-shrink-0 focus:outline-none mx-2 block text-blue-600 hover:text-blue-700 w-6 h-6">
                            <svg viewBox="0 0 20 20" class="w-full h-full fill-current">
                                <path d="M0,6.00585866 C0,4.89805351 0.893899798,4 2.0048815,4 L5,4 L7,2 L13,2 L15,4 L17.9951185,4 C19.102384,4 20,4.89706013 20,6.00585866 L20,15.9941413 C20,17.1019465 19.1017876,18 18.0092049,18 L1.99079514,18 C0.891309342,18 0,17.1029399 0,15.9941413 L0,6.00585866 Z M10,16 C12.7614237,16 15,13.7614237 15,11 C15,8.23857625 12.7614237,6 10,6 C7.23857625,6 5,8.23857625 5,11 C5,13.7614237 7.23857625,16 10,16 Z M10,14 C11.6568542,14 13,12.6568542 13,11 C13,9.34314575 11.6568542,8 10,8 C8.34314575,8 7,9.34314575 7,11 C7,12.6568542 8.34314575,14 10,14 Z"/>
                            </svg>
                        </button>
                        <button type="button" class="flex flex-shrink-0 focus:outline-none mx-2 block text-blue-600 hover:text-blue-700 w-6 h-6">
                            <svg viewBox="0 0 20 20" class="w-full h-full fill-current">
                                <path d="M9,18 L9,16.9379599 C5.05368842,16.4447356 2,13.0713165 2,9 L4,9 L4,9.00181488 C4,12.3172241 6.6862915,15 10,15 C13.3069658,15 16,12.314521 16,9.00181488 L16,9 L18,9 C18,13.0790094 14.9395595,16.4450043 11,16.9378859 L11,18 L14,18 L14,20 L6,20 L6,18 L9,18 L9,18 Z M6,4.00650452 C6,1.79377317 7.79535615,0 10,0 C12.209139,0 14,1.79394555 14,4.00650452 L14,8.99349548 C14,11.2062268 12.2046438,13 10,13 C7.790861,13 6,11.2060545 6,8.99349548 L6,4.00650452 L6,4.00650452 Z" />
                            </svg>
                        </button>
                        -->
                        <div class="relative flex-grow">
                            <label>
                                <input 
                                  v-model="message"
                                  @keyup.enter="sendMessage(chat.claimId)"
                                  class="rounded-full py-2 pl-3 pr-10 w-full border border-gray-800 focus:border-gray-700 bg-gray-800 focus:bg-gray-900 focus:outline-none text-gray-200 focus:shadow-md transition duration-300 ease-in"
                                  type="text"
                                  placeholder="Aa"/>
                                <button @click="sendMessage(chat.claimId)" type="button" class="absolute top-0 right-0 mt-2 mr-3 flex flex-shrink-0 focus:outline-none block text-blue-600 hover:text-blue-700 w-6 h-6">
                                    <svg viewBox="0 0 20 20" class="w-full h-full fill-current">
                                        <path d="M12.522,10.4l-3.559,3.562c-0.172,0.173-0.451,0.176-0.625,0c-0.173-0.173-0.173-0.451,0-0.624l3.248-3.25L8.161,6.662c-0.173-0.173-0.173-0.452,0-0.624c0.172-0.175,0.451-0.175,0.624,0l3.738,3.736C12.695,9.947,12.695,10.228,12.522,10.4 M18.406,10c0,4.644-3.764,8.406-8.406,8.406c-4.644,0-8.406-3.763-8.406-8.406S5.356,1.594,10,1.594C14.643,1.594,18.406,5.356,18.406,10M17.521,10c0-4.148-3.374-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.147,17.521,10"></path>                                    
                                    </svg>
                                </button>
                            </label>
                        </div>
                        <!--
                        <button type="button" class="flex flex-shrink-0 focus:outline-none mx-2 block text-blue-600 hover:text-blue-700 w-6 h-6">
                            <svg viewBox="0 0 20 20" class="w-full h-full fill-current">
                                <path d="M11.0010436,0 C9.89589787,0 9.00000024,0.886706352 9.0000002,1.99810135 L9,8 L1.9973917,8 C0.894262725,8 0,8.88772964 0,10 L0,12 L2.29663334,18.1243554 C2.68509206,19.1602453 3.90195042,20 5.00853025,20 L12.9914698,20 C14.1007504,20 15,19.1125667 15,18.000385 L15,10 L12,3 L12,0 L11.0010436,0 L11.0010436,0 Z M17,10 L20,10 L20,20 L17,20 L17,10 L17,10 Z"/>
                            </svg>
                        </button>
                        -->
                    </div>
                </div>
            </section>
        </main>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify';
import '@/filter.js'

Vue.use(VueAlertify);

export default {

  data() {
    return {
        chat: null,
        message: '',
        people: [],
        search: ''
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init () {
        this.getChat()
    },
    async getChat() {
      const claimId = this.$route.params.claimId
      if (claimId != 'all'){
          this.chat = await this.$http.get(`chats/claim/${claimId}`)
          this.people[0] = { contact: this.chat.contact, claimId: this.chat.claimId }
          this.people[0].lastMessage = this.chat.chat.slice(-1)[0]
          this.people[0].active = true
      } else {
          const response = await this.$http.get('chats/noread/all/claim')
          if (response.results.length > 0){
              this.chat = {
                contact: response.results[0].contact, 
                claimId: response.results[0].claimId,
                chat: response.results[0].chat
              }
              let k = 0
              response.results.forEach(e => {
                const lastMessage = e.chat.slice(-1)[0]
                delete e.chat
                e.lastMessage = lastMessage
                e.active = (k == 0) ? true : false
                this.people.push(e)
                k++
              })
          }        
      }
    },
    async sendMessage(claimId) {
        try {
            const chat = {
                message: this.message,
                claim_id: claimId,
            }
            await this.$http.post('chats', chat)
            this.message = ''
            this.chat = await this.$http.get(`chats/claim/${claimId}`)
            this.people[0].lastMessage = this.chat.chat.slice(-1)[0]
        } catch (error) {
            this.$alertify.error('ERROR. No se ha podido enviar el mensaje!')
        }    
    },
    async change(claimId) {
        this.chat = await this.$http.get(`chats/claim/${claimId}`)
        this.people[0].active = false
        let p = { contact: this.chat.contact, claimId: this.chat.claimId }
        p.lastMessage = this.chat.chat.slice(-1)[0]
        p.active = true
        this.people = this.people.filter(p => p.claimId != claimId)
        this.people.unshift(p)
    },
    async searchContact() {
        if (this.search != ''){
            this.people = []
            this.chat = null
            const response = await this.$http.get(`chats/search/${this.search}`)
            if (response.results.length > 0){
                this.chat = {
                    contact: response.results[0].contact, 
                    claimId: response.results[0].claimId,
                    chat: response.results[0].chat
                }
                let k = 0
                let people = []
                response.results.forEach(e => {
                    const lastMessage = e.chat.slice(-1)[0]
                    delete e.chat
                    e.lastMessage = lastMessage
                    e.active = (k == 0) ? true : false
                    people.push(e)
                    k++
                })
                this.people = people
            }
        }
    }
  }, 
  
}
</script>
